module.exports = __webpack_public_path__ + "static/media/rahul.675e486e.jpg";